<template>
  <div>
    <v-text-field 
      :value="value" 
      :label="label"
      :placeholder='placeholder'
      :rules="rules"
      min
      max
      dense
      outlined
      type='number'
      @input="handleInput"
    >
    <template v-slot:append-outer>
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on }">
          <a v-on="on" @click="toleranceChange">
            <v-icon :color="toleranceColor">mdi-plus-minus</v-icon>
          </a>
        </template>
        {{toleranceTooltip}}
      </v-tooltip>
    </template>
    </v-text-field>
  </div>
</template>

<script>
  export default {
    name: 'TolerentField',
    props: {
      label: String,
      value: String,
      min: Number,
      max: Number,
      tolerance: Boolean,
      updateTolerance: Function,
    },
    computed: {
      minStr() {
        return this.min.toString().replace(/\./, ',');
      },
      maxStr() {
        return this.max.toString().replace(/\./, ',');
      },
      placeholder() {
        return `Entre ${this.minStr} et ${this.maxStr}`
      },
      rules() {
        return [
          v => !v || v >= this.min || `Saisir au minimum ${this.minStr}`,
          v => !v || v <= this.max || `Saisir au maximum ${this.maxStr}`,
        ]
      },
      toleranceColor() {
        return this.tolerance ? 'blue' : 'black'
      },
      toleranceTooltip() {
        return this.tolerance ? 'Désactiver la tolérance de ± 10%' : 'Activer une tolérance de ± 10%'
      }
    },
    methods: {
      handleInput(newValue) {
        this.$emit('input', newValue);
      },
      toleranceChange() {
        this.updateTolerance(!this.tolerance);
      }
    },
  }
</script>